import React, { useState, useEffect } from 'react';
import {
  Input,
  Modal,
  Tooltip,
  Button,
  Typography,
  Row,
  Col,
  Form,
} from 'antd';
import { InfoCircleFilled } from '@ant-design/icons';
import { incrementUIRequestsCounter } from '../../redux/utils/websocket/incrementUIRequestsCounter';
const SavedRecipeModal = (props) => {
  const { Text } = Typography;
  const { TextArea } = Input;
  const [form] = Form.useForm();

  const [isValid, setIsValid] = useState(true);

  const recipeName = Form.useWatch('recipeName', form);
  const recipeDescription = Form.useWatch('recipeDescription', form);

  useEffect(() => {
    if (props.isModalVisible) {
      if (props?.type === 'saveAs' || props?.type === 'edit') {
        setIsValid(true);
        form.setFieldsValue({
          recipeName: props?.loadedRecipe?.name,
          recipeDescription: props?.loadedRecipe?.description,
        });
      } else {
        form.resetFields();
      }
    }
  }, [props.isModalVisible]);

  const setValues = (values) => {
    props.setNameOfNewQuery(form.getFieldValue('recipeName'));
    props.setDescriptionOfNewQuery(form.getFieldValue('recipeDescription'));
    setIsValid(true);
  };

  const returnTitle = () => {
    switch (props?.type) {
      case 'edit':
        return 'Edit Recipe';
      case 'saveAs':
        return 'Save As';
      default:
        return 'Save Recipe';
    }
  };

  return (
    <Modal
      title={returnTitle()}
      centered
      width={400}
      closable={false}
      open={props?.isModalVisible}
      footer={[
        <Button key="cancel" type="link" onClick={() => props?.handleCancel()}>
          Cancel
        </Button>,
        <Button
          key="submit"
          type="primary"
          onClick={() => {
            props?.handleOk(props?.type);
            incrementUIRequestsCounter();
          }}
          disabled={!recipeName || !isValid}
        >
          Save
        </Button>,
      ]}
    >
      <Form form={form} onValuesChange={setValues} name="saveRecipeForm">
        <Text>
          Recipe Name (required)
          <Tooltip
            placement="right"
            title="Maximum 40 characters, only letters and numbers allowed."
          >
            <InfoCircleFilled className="ms-05" />
          </Tooltip>
        </Text>

        <Form.Item
          className="m-0"
          name="recipeName"
          rules={[
            ({ getFieldValue }) => ({
              validator(fieldObject, fieldValue) {
                const specialCharacters = new RegExp(
                  /^[0-9A-Za-z/.:/_\*-\s\[\]]+$/,
                );

                if (specialCharacters.test(fieldValue)) {
                  setIsValid(true);
                  return Promise.resolve();
                } else if (fieldValue?.length > 0) {
                  setIsValid(false);
                  return Promise.reject('Special characters are not allowed.');
                } else if (fieldValue?.length === 0) {
                  setIsValid(false);
                  return Promise.reject();
                }
              },
            }),
            {
              required: true,
              message: 'Please add a recipe name!',
            },
          ]}
        >
          <Input maxLength={40} placeholder="Enter Recipe Name" />
        </Form.Item>

        <Text className="mb-1">
          {props?.type === 'saveAs' || props?.type === 'edit'
            ? props?.loadedRecipe?.name?.length
            : props?.nameOfNewQuery?.length}{' '}
          / 40 Characters
        </Text>

        <Row className="mt-1">
          <Col xs={24}>
            <Text>
              Recipe Description
              <Tooltip
                placement="right"
                title="Maximum 3.000 characters allowed."
              >
                <InfoCircleFilled className="ms-05" />
              </Tooltip>
            </Text>

            <Form.Item className="m-0" name="recipeDescription">
              <TextArea
                rows={5}
                placeholder="Enter Recipe Description"
                maxLength={3000}
              />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default SavedRecipeModal;
